import ArticleNumber from "../ArticleNumber/ArticleNumber";

import type { JSX } from "react";

import {
  Description,
  FormattedStaticCurrencyNumber,
  useTranslatedProductDescription,
  useTranslatedProductName,
} from "@4pace-cpq/core";
import { VMSubItems } from "@4pace-cpq/core/api";
import { TableCell, TableRow } from "@mui/material";

export function SubItem({
  item,
  lineItemQuantity,
}: {
  item: VMSubItems;
  lineItemQuantity: number;
}): JSX.Element {
  const translatedName = useTranslatedProductName(item);
  const translatedDescription = useTranslatedProductDescription(item);

  if (!item) {
    return <></>;
  }
  const currencyIdentifier = item.currency?.identifier;

  return (
    <TableRow>
      <TableCell
        sx={{
          width: "80px",
        }}
      >
        <ArticleNumber item={item} />
      </TableCell>
      <TableCell
        sx={{
          width: "200px",
        }}
      >
        {translatedName ?? "-"}
      </TableCell>
      <TableCell>
        {item.product && (
          <Description maxWidth="50ch" text={translatedDescription} />
        )}
      </TableCell>
      <TableCell>
        {item.quantity ? item.quantity * lineItemQuantity : null}
      </TableCell>
      <TableCell>
        <FormattedStaticCurrencyNumber
          value={item.listPrice}
          currencyIdentifier={currencyIdentifier}
        />
      </TableCell>
      <TableCell>
        <FormattedStaticCurrencyNumber
          value={item.totalList ? item.totalList * lineItemQuantity : null}
          currencyIdentifier={currencyIdentifier}
        />
      </TableCell>
    </TableRow>
  );
}
